import { PRODUCT_QUERY_LIMIT } from "./constants";

export function buildGetOwnedProductsVariables(searchText, lastRecord) {
  const variables = {
    name: {}
  };

  variables.name = {
    ...variables.name,
    contains: searchText,
    orderBy: "Ascending",
    ...(lastRecord && {
      cursor: lastRecord.name
    })
  };

  return {
    variables: {
      ...variables,
      ...(lastRecord && { cursor: lastRecord.id }),
      limit: PRODUCT_QUERY_LIMIT
    }
  };
}

export async function fetchMoreProducts({
  fetchMore,
  searchText,
  products,
  preventRefetch
}) {
  await fetchMore({
    ...buildGetOwnedProductsVariables(searchText, products.slice(-1)[0]),
    updateQuery: (previousResult, { fetchMoreResult }) => {
      if (fetchMoreResult.stores.ownedProducts.length < PRODUCT_QUERY_LIMIT) {
        preventRefetch.current = true;
      }

      return {
        ...previousResult,
        stores: {
          // eslint-disable-next-line no-underscore-dangle
          __typename: previousResult.stores.__typename,
          ownedProducts: [
            ...previousResult.stores.ownedProducts,
            ...fetchMoreResult.stores.ownedProducts
          ]
        }
      };
    }
  });
}

export function buildExportProductsVariables({ searchText }) {
  const product = {
    name: {}
  };

  product.name = {
    ...product.name,
    contains: searchText
  };

  return {
    variables: {
      product
    }
  };
}
